import { Children } from "~/types"

const ValidationError = ({ children }: Children) => {
  return <div className="mt-1 text-xs text-red-700">{children}</div>
}

export default ValidationError
